import { render, staticRenderFns } from "./EventSubdomain.vue?vue&type=template&id=7720b224"
import script from "./EventSubdomain.vue?vue&type=script&lang=js"
export * from "./EventSubdomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports